/* eslint-disable complexity */ import { jsx as _jsx } from "react/jsx-runtime";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import classNames from "classnames";
import * as React from "react";
import { isResponsiveProp } from "../Theme/ResponsiveProp";
// eslint-disable-next-line import/no-unassigned-import
import "./native-styles.css";
/**
 * @trackcomponent
 */ export var LoadingSkeletonBase = function(param) {
    var className = param.className, dataTestId = param["data-test-id"], ariaLabel = param.ariaLabel, _param_animated = param.animated, animated = _param_animated === void 0 ? true : _param_animated, width = param.width, height = param.height, aspectRatio = param.aspectRatio, borderRadius = param.borderRadius;
    var vars = {};
    var classes = [];
    if (isResponsiveProp(width)) {
        var _width_mobileAndAbove;
        vars["--f_ls_width_default"] = (_width_mobileAndAbove = width.mobileAndAbove) === null || _width_mobileAndAbove === void 0 ? void 0 : _width_mobileAndAbove.toString();
        classes.push("f_ls_width_default");
        if (width.tabletAndAbove) {
            var _width_tabletAndAbove;
            vars["--f_ls_width_tablet"] = (_width_tabletAndAbove = width.tabletAndAbove) === null || _width_tabletAndAbove === void 0 ? void 0 : _width_tabletAndAbove.toString();
            classes.push("f_ls_width_tablet");
        }
        if (width.desktopAndAbove) {
            var _width_desktopAndAbove;
            vars["--f_ls_width_desktop"] = (_width_desktopAndAbove = width.desktopAndAbove) === null || _width_desktopAndAbove === void 0 ? void 0 : _width_desktopAndAbove.toString();
            classes.push("f_ls_width_desktop");
        }
        if (width.xLargeAndAbove) {
            var _width_xLargeAndAbove;
            vars["--f_ls_width_xlarge"] = (_width_xLargeAndAbove = width.xLargeAndAbove) === null || _width_xLargeAndAbove === void 0 ? void 0 : _width_xLargeAndAbove.toString();
            classes.push("f_ls_width_xlarge");
        }
        if (width.xxLargeDesktop) {
            var _width_xxLargeDesktop;
            vars["--f_ls_width_xxlarge"] = (_width_xxLargeDesktop = width.xxLargeDesktop) === null || _width_xxLargeDesktop === void 0 ? void 0 : _width_xxLargeDesktop.toString();
            classes.push("f_ls_width_xxlarge");
        }
    } else {
        vars["--f_ls_width_default"] = width === null || width === void 0 ? void 0 : width.toString();
        classes.push("f_ls_width_default");
    }
    if (isResponsiveProp(height)) {
        var _height_mobileAndAbove;
        vars["--f_ls_height_default"] = (_height_mobileAndAbove = height.mobileAndAbove) === null || _height_mobileAndAbove === void 0 ? void 0 : _height_mobileAndAbove.toString();
        classes.push("f_ls_height_default");
        if (height.tabletAndAbove) {
            var _height_tabletAndAbove;
            vars["--f_ls_height_tablet"] = (_height_tabletAndAbove = height.tabletAndAbove) === null || _height_tabletAndAbove === void 0 ? void 0 : _height_tabletAndAbove.toString();
            classes.push("f_ls_height_tablet");
        }
        if (height.desktopAndAbove) {
            var _height_desktopAndAbove;
            vars["--f_ls_height_desktop"] = (_height_desktopAndAbove = height.desktopAndAbove) === null || _height_desktopAndAbove === void 0 ? void 0 : _height_desktopAndAbove.toString();
            classes.push("f_ls_height_desktop");
        }
        if (height.xLargeAndAbove) {
            var _height_xLargeAndAbove;
            vars["--f_ls_height_xlarge"] = (_height_xLargeAndAbove = height.xLargeAndAbove) === null || _height_xLargeAndAbove === void 0 ? void 0 : _height_xLargeAndAbove.toString();
            classes.push("f_ls_height_xlarge");
        }
        if (height.xxLargeDesktop) {
            var _height_xxLargeDesktop;
            vars["--f_ls_height_xxlarge"] = (_height_xxLargeDesktop = height.xxLargeDesktop) === null || _height_xxLargeDesktop === void 0 ? void 0 : _height_xxLargeDesktop.toString();
            classes.push("f_ls_height_xxlarge");
        }
    } else {
        vars["--f_ls_height_default"] = height === null || height === void 0 ? void 0 : height.toString();
        classes.push("f_ls_height_default");
    }
    if (isResponsiveProp(aspectRatio)) {
        var _aspectRatio_mobileAndAbove;
        vars["--f_ls_aspect_ratio_default"] = (_aspectRatio_mobileAndAbove = aspectRatio.mobileAndAbove) === null || _aspectRatio_mobileAndAbove === void 0 ? void 0 : _aspectRatio_mobileAndAbove.toString();
        classes.push("f_ls_aspect_ratio_default");
        if (aspectRatio.tabletAndAbove) {
            var _aspectRatio_tabletAndAbove;
            vars["--f_ls_aspect_ratio_tablet"] = (_aspectRatio_tabletAndAbove = aspectRatio.tabletAndAbove) === null || _aspectRatio_tabletAndAbove === void 0 ? void 0 : _aspectRatio_tabletAndAbove.toString();
            classes.push("f_ls_aspect_ratio_tablet");
        }
        if (aspectRatio.desktopAndAbove) {
            var _aspectRatio_desktopAndAbove;
            vars["--f_ls_aspect_ratio_desktop"] = (_aspectRatio_desktopAndAbove = aspectRatio.desktopAndAbove) === null || _aspectRatio_desktopAndAbove === void 0 ? void 0 : _aspectRatio_desktopAndAbove.toString();
            classes.push("f_ls_aspect_ratio_desktop");
        }
        if (aspectRatio.xLargeAndAbove) {
            var _aspectRatio_xLargeAndAbove;
            vars["--f_ls_aspect_ratio_xlarge"] = (_aspectRatio_xLargeAndAbove = aspectRatio.xLargeAndAbove) === null || _aspectRatio_xLargeAndAbove === void 0 ? void 0 : _aspectRatio_xLargeAndAbove.toString();
            classes.push("f_ls_aspect_ratio_xlarge");
        }
        if (aspectRatio.xxLargeDesktop) {
            var _aspectRatio_xxLargeDesktop;
            vars["--f_ls_aspect_ratio_xxlarge"] = (_aspectRatio_xxLargeDesktop = aspectRatio.xxLargeDesktop) === null || _aspectRatio_xxLargeDesktop === void 0 ? void 0 : _aspectRatio_xxLargeDesktop.toString();
            classes.push("f_ls_aspect_ratio_xxlarge");
        }
    } else {
        vars["--f_ls_aspect_ratio_default"] = aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.toString();
        classes.push("f_ls_aspect_ratio_default");
    }
    if (isResponsiveProp(borderRadius)) {
        var _borderRadius_mobileAndAbove;
        vars["--f_ls_border_radius_default"] = (_borderRadius_mobileAndAbove = borderRadius.mobileAndAbove) === null || _borderRadius_mobileAndAbove === void 0 ? void 0 : _borderRadius_mobileAndAbove.toString();
        classes.push("f_ls_border_radius_default");
        if (borderRadius.tabletAndAbove) {
            var _borderRadius_tabletAndAbove;
            vars["--f_ls_border_radius_tablet"] = (_borderRadius_tabletAndAbove = borderRadius.tabletAndAbove) === null || _borderRadius_tabletAndAbove === void 0 ? void 0 : _borderRadius_tabletAndAbove.toString();
            classes.push("f_ls_border_radius_tablet");
        }
        if (borderRadius.desktopAndAbove) {
            var _borderRadius_desktopAndAbove;
            vars["--f_ls_border_radius_desktop"] = (_borderRadius_desktopAndAbove = borderRadius.desktopAndAbove) === null || _borderRadius_desktopAndAbove === void 0 ? void 0 : _borderRadius_desktopAndAbove.toString();
            classes.push("f_ls_border_radius_desktop");
        }
        if (borderRadius.xLargeAndAbove) {
            var _borderRadius_xLargeAndAbove;
            vars["--f_ls_border_radius_xlarge"] = (_borderRadius_xLargeAndAbove = borderRadius.xLargeAndAbove) === null || _borderRadius_xLargeAndAbove === void 0 ? void 0 : _borderRadius_xLargeAndAbove.toString();
            classes.push("f_ls_border_radius_xlarge");
        }
        if (borderRadius.xxLargeDesktop) {
            var _borderRadius_xxLargeDesktop;
            vars["--f_ls_border_radius_xxlarge"] = (_borderRadius_xxLargeDesktop = borderRadius.xxLargeDesktop) === null || _borderRadius_xxLargeDesktop === void 0 ? void 0 : _borderRadius_xxLargeDesktop.toString();
            classes.push("f_ls_border_radius_xxlarge");
        }
    } else {
        vars["--f_ls_border_radius_default"] = borderRadius === null || borderRadius === void 0 ? void 0 : borderRadius.toString();
        classes.push("f_ls_border_radius_default");
    }
    return /*#__PURE__*/ _jsx("div", {
        role: "status",
        "aria-label": ariaLabel,
        "data-test-id": dataTestId,
        style: assignInlineVars(vars),
        className: classNames(className, "f_ls_container", classes),
        children: /*#__PURE__*/ _jsx("div", {
            className: classNames(className, "f_ls_static", classes),
            children: animated ? /*#__PURE__*/ _jsx("div", {
                className: classNames(className, "f_ls_animated", classes)
            }) : null
        })
    });
};
